import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

export type WatchTab = "vulnerabilities" | "portal" | "sources";

export const WATCH_TABS: readonly WatchTab[] = ["vulnerabilities", "portal", "sources"];

export function parseWatchTab(params: URLSearchParams): WatchTab {
  return WATCH_TABS.find((tab) => tab === params.get("tab")) ?? "vulnerabilities";
}

/** The tab the URL names. Choosing one adds a history entry and starts that tab without filters. */
export function useWatchTab(): [WatchTab, (tab: WatchTab) => void] {
  const [params, setParams] = useSearchParams();
  const selectTab = useCallback(
    (tab: WatchTab) => setParams(tab === "vulnerabilities" ? new URLSearchParams() : new URLSearchParams({ tab })),
    [setParams],
  );
  return [parseWatchTab(params), selectTab];
}
